import { render, staticRenderFns } from "./ItemRequestResultModal.vue?vue&type=template&id=45835dd8&scoped=true&"
import script from "./ItemRequestResultModal.vue?vue&type=script&lang=ts&"
export * from "./ItemRequestResultModal.vue?vue&type=script&lang=ts&"
import style0 from "./ItemRequestResultModal.vue?vue&type=style&index=0&id=45835dd8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45835dd8",
  null
  
)

export default component.exports